import type {PerkIntegrationConfigComponentProps} from '@cohort/merchants/apps';
import CohortFormConfig from '@cohort/merchants/apps/cohort-form/components/CohortFormConfig';
import {useCurrentPerk} from '@cohort/merchants/hooks/contexts/currentPerk';
import {useCohortForm} from '@cohort/merchants/hooks/contexts/form';
import type {PerkFormValues} from '@cohort/merchants/pages/perks/perk/edit/utils';
import {CohortFormConfigSchema} from '@cohort/shared/schema/common/cohortForm';
import {useEffect} from 'react';

const CohortFormPerkIntegrationConfigComponent: React.FC<
  PerkIntegrationConfigComponentProps
> = () => {
  const perk = useCurrentPerk();
  const {register, control, setValue} = useCohortForm<PerkFormValues>();
  const parsedConfig = CohortFormConfigSchema.optional().safeParse(perk.integration?.config);
  const existingConfig = parsedConfig.success ? parsedConfig.data : null;

  useEffect(() => {
    setValue('maxUsagesPerToken', 1);
  }, [perk.integration?.config, setValue]);

  return (
    <CohortFormConfig
      register={register}
      control={control}
      fieldPaths={{
        prompts: 'integration.config.prompts',
      }}
      existingConfig={existingConfig}
    />
  );
};

export default CohortFormPerkIntegrationConfigComponent;
